import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Company = lazy(() => import('../../container/users/Company'));

function CompanyRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}`} component={Company} />
    </Switch>
  );
}

export default CompanyRoutes;
